import { createSlice } from '@reduxjs/toolkit';

import { initialState, dashboardAdapter } from './dashboard.state';
import {
  calendarReducers,
  dashboardDetailReducers,
  electronicServicesReducers,
  personalLinksReducers,
  fastActionsReducers,
  taskListReducers,
  externalReducers,
  partitionsReducers,
  widgetsReducers,
  PersonalLinksSettingsReducers,
  settingsUserSectionReducer,
} from './actions';

export const dashboard = createSlice({
  name: 'dashboard',
  initialState: dashboardAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    dashboardDetailReducers(builder);
    electronicServicesReducers(builder);
    personalLinksReducers(builder);
    fastActionsReducers(builder);
    taskListReducers(builder);
    externalReducers(builder);
    calendarReducers(builder);
    partitionsReducers(builder);
    widgetsReducers(builder);
    PersonalLinksSettingsReducers(builder);
    settingsUserSectionReducer(builder);
  },
});

export const dashboardReducer = dashboard.reducer;
